import { MessageCircle } from "lucide-react";
import { fmtPrice } from "@/lib/utils";

export const WhatsAppShareButton = ({ annonce, className = "" }) => {
  if (!annonce || annonce.category !== "Immobilier") return null;
  const url = `${window.location.origin}/annonces/${annonce.ref || annonce.id}`;
  const lieu = [annonce.city, annonce.quartier].filter(Boolean).join(", ");
  const text = [
    `🏠 ${annonce.title}`,
    annonce.price ? `💰 ${fmtPrice(annonce.price, annonce.price_unit || "")}` : null,
    lieu ? `📍 ${lieu}` : null,
    "",
    `Vu sur Fodindin : ${url}`,
  ].filter((l) => l !== null).join("\n");
  const href = `https://wa.me/?text=${encodeURIComponent(text)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={`inline-flex items-center justify-center gap-2 w-full font-bold px-3 py-2.5 rounded-full border-2 border-emerald-500 text-emerald-700 bg-white hover:bg-emerald-50 transition-colors ${className}`}
      data-testid="whatsapp-share-btn"
    >
      <MessageCircle size={16} /> Partager sur WhatsApp
    </a>
  );
};
